var map = {
	"./": [
		35188,
		5188
	],
	"./bsc": [
		21461,
		1461
	],
	"./bsc.ts": [
		21461,
		1461
	],
	"./bscTestnet": [
		53266,
		2819
	],
	"./bscTestnet.ts": [
		53266,
		2819
	],
	"./goerli": [
		46516,
		6516
	],
	"./goerli.ts": [
		46516,
		6516
	],
	"./index": [
		35188,
		5188
	],
	"./index.ts": [
		35188,
		5188
	],
	"./polygonZkEVM": [
		98630,
		8630
	],
	"./polygonZkEVM.ts": [
		98630,
		8630
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 24615;
module.exports = webpackAsyncContext;